// File: src/views/Link.js
import React, { useState } from 'react';
import { Box, Typography, Button, Stack, Dialog, Chip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LinkIcon from '@mui/icons-material/Link';

const MAIL = 'hey@kajikaaki.com';

const links = [
  { label: 'Discover my gallery', href: '/', external: false },
  // { label: 'Request a commission', href: `mailto:${MAIL}`, external: true }, // <-- géré à part avec fallback
  { label: 'Shop the Flowers of Joy', href: 'https://www.singulart.com/fr/artiste/kajika-aki-76732', external: true },
  { label: 'Shop my line drawings', href: '/line', external: false },
];

const LinkPage = () => {
  const [fallbackOpen, setFallbackOpen] = useState(false);

  const openMail = (href) => {
    try {
      window.location.href = href; // réduit les pop-up blockers
    } catch (_) { /* noop */ }
    // Si rien ne se passe (bloqué / pas de handler), on montre le fallback
    setTimeout(() => setFallbackOpen(true), 900);
  };

  const handleCommissionClick = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent('Commission request');
    const body = encodeURIComponent(
      `Hello,\n\nI'd love to commission a piece.\nCould you share availability, pricing, and process details?\n\nThank you!\n`
    );
    const href = `mailto:${MAIL}?subject=${subject}&body=${body}`;
    openMail(href);
  };

  const handleCopy = async () => {
    try { await navigator.clipboard.writeText(MAIL); } catch (_) { /* ignore */ }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        py: 8,
        px: 2,
      }}
    >
      {/* Logo / Title */}
      <Typography
        variant="h4"
        sx={{
          fontFamily: 'Ranade, sans-serif',
          fontWeight: 300,
          letterSpacing: '0.02em',
          color: '#000000',
          mb: 1,
          cursor: 'pointer',
        }}
      >
        KAJIKA AKI
      </Typography>
      <Chip icon={<LinkIcon />} label="Explore my links" variant="outlined" sx={{ mb:4, pl:0.5 }}/>

      {/* Links */}
      <Stack spacing={2} sx={{ width: '100%', maxWidth: 360 }}>
        {/* Commission with mailto + fallback */}
        <Button
          variant="outlined"
          onClick={handleCommissionClick}
          fullWidth
          sx={{
            borderRadius: '12px',
            textTransform: 'none',
            fontFamily: 'Manrope, sans-serif',
            fontSize: '1rem',
            py: 1.5,
            borderColor: '#000',
            color: '#000',
            '&:hover': { bgcolor: '#000', color: '#fff', borderColor: '#000' },
          }}
        >
          Request a commission
        </Button>

        {links.map((link, i) => (
          <Button
            key={i}
            variant="outlined"
            href={link.href}
            target={link.external ? '_blank' : '_self'}
            rel={link.external ? 'noopener noreferrer' : undefined}
            fullWidth
            sx={{
              borderRadius: '12px',
              textTransform: 'none',
              fontFamily: 'Manrope, sans-serif',
              fontSize: '1rem',
              py: 1.5,
              borderColor: '#000',
              color: '#000',
              '&:hover': { bgcolor: '#000', color: '#fff', borderColor: '#000' },
            }}
          >
            {link.label}
          </Button>
        ))}
      </Stack>

      {/* Fallback dialog if mailto blocked */}
      <Dialog open={fallbackOpen} onClose={() => setFallbackOpen(false)} PaperProps={{ sx: { p: 0 } }}>
        <Box sx={{ p: 5, maxWidth: 520 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>Want a commission?</Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, mb: 3 }}>
            If your email app didn’t open, just drop me a message at <strong>{MAIL}</strong>.
            Tell me a bit about the piece you have in mind (format, style, timing).
          </Typography>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
            <Button startIcon={<ContentCopyIcon />} onClick={handleCopy}>Copy email</Button>
          </Stack>
        </Box>
      </Dialog>
    </Box>
  );
};

export default LinkPage;
